import * as actions from "Actions";
import * as api from "Api";

export const fetchAnalysisPlanSuggestions = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    return dispatch(
      actions.getAnalysesPlanSuggestions(
        api.getAnalysisPlanSuggestions(currentOrganization.id)
      )
    );
  };
};

export const updateAnalysisPlanSettings = (categoryId, labels) => (
  dispatch,
  getState
) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.updateAnalysisPlanSettings(
      api.updateAnalysisPlanSettings({
        organization: currentOrganization.id,
        id: categoryId,
        labels: labels
      })
    )
  );
};

export const deleteAnalysisPlanSettings = (categoryId, isForced) => (
  dispatch,
  getState
) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.deleteAnalysisPlanSettings(
      api.deleteAnalysisPlanSettings({
        organization: currentOrganization.id,
        isForced: isForced,
        id: categoryId
      })
    )
  );
};

export const saveAnalysisPlanSettings = labels => (dispatch, getState) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.saveAnalysisPlanSettings(
      api.saveAnalysisPlanSettings({
        organization: currentOrganization.id,
        labels: labels
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/analysis-plan.js